import type { AIInsight } from '../types/contracts';

export function KpiStrip({ items }: { items: AIInsight[] }) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-6 gap-2">
      {items.map((k) => (
        <div key={k.id} className="rounded-xl bg-white border border-gray-100 px-3 py-2.5 flex items-center justify-between gap-2">
          <span className="text-[11px] font-semibold text-gray-500 leading-tight">{k.label}</span>
          <span className="text-lg font-black text-gray-900">{k.value}</span>
        </div>
      ))}
    </div>
  );
}
